import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) {}

  getReportData(endpoint: string, params?: any) {
    return this.http.get<any[]>(endpoint, { params });
  }
}
